import React from 'react';
import SEO from '../components/SEO';

const Darbostogos = () => {
  return (
    <div>
      <SEO 
        title="Darbostogos"
        description="Darbostogos Sporto Krante - derinkit darbą ir poilsį gamtos apsuptyje. Moderni darbo erdvė, greitas internetas, pramogos po darbo valandų."
        keywords="darbostogos, workation, nuotolinis darbas, poilsis gamtoje, darbo erdvė, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/darbostogos"
      />
      {/* Hero Section - White background with image left, text right */}
      <section className="border-b-[3px] border-black bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* Image */}
          <div className="h-[400px] lg:h-[700px] overflow-hidden">
            <img 
              src="/img/darbostogos-1.jpg" 
              alt="Darbostogos" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="h-auto lg:h-[700px] px-8 py-8 lg:py-0 lg:px-12 flex flex-col justify-center items-center text-center">
            <h1 className="text-black mb-6 tracking-wide leading-tight" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
              PAKEISKITE APLINKĄ - PASIRINKITE MŪSŲ DARBOSTOGŲ IR RENGINIŲ KOMPLEKSĄ PRIE EŽERO
            </h1>
            <div className="space-y-2 text-black leading-relaxed">
              <p>
                Norite atitrūkti nuo miesto tempo ir su komanda padirbėti strateginėje sesijoje ar paminėti įmonės renginį? Atvykite pas mus į Vilniaus rajone įsikūrusį Sporto centrą - siūlome unikalią patirtį. Dieną dirbkite bendradarbystės erdvėse, vakare mėgaukitės pirties, jacuzzi ir nuostabios gamtos malonumais. Darbostogos - be rūpesčių. Mes pasirūpinsime viskuom: jūsų darbu, poilsiu, maitinimu ir pramogomis.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Rest Section - Gold background */}
      <section className="py-12 border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-center text-black mb-6 tracking-wide" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            KOKYBIŠKAS POILSIS IR APGYVENDINIMAS
          </h2>
          <div className="space-y-2 text-black leading-relaxed text-center max-w-4xl mx-auto mb-8">
            <p>
              Pramogų ir laisvalaikio centre „Sporto krantas" didelis dėmesys skiriamas ramybei, patogumui ir poilsio kokybei. Čia įrengta 13 šviesių, modernaus dizaino kambarių, pritaikytų atvykstančioms komandoms. Galimi dviviečiai ir šeimyniniai kambariai, kuriuose dera funkcionalumas, jaukumas ir estetinė švara.
            </p>
            <p>
              Pro langus atsiveria ramūs ežero arba miško vaizdai, kurie natūraliai padeda atsijungti nuo kasdienio tempo ir kuria tikro poilsio jausmą.
            </p>
          </div>

          {/* Two images side by side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="/img/darbostogos-2.jpg" 
                alt="Kambariai" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="/img/darbostogos-3.jpg" 
                alt="Poilsio erdvė" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SPA Section - Dark background, text left (60%), image right (40%) */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Content - 60% */}
          <div className="lg:col-span-6 px-8 py-12 lg:px-16 lg:py-16 flex flex-col justify-center items-center">
            <div className="max-w-lg">
              <h2 className="text-white mb-6 tracking-wide text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
                SPA poilsis darbostogoms ir komandoms
              </h2>
              <div className="space-y-2 text-white leading-relaxed mb-6 text-left">
                <p>
                  Svečiuodamiesi „Sporto krante", nepraleiskite progos pasimėgauti SPA erdve, sukurta tikram atsistatymui po darbo, susitikimų ir aktyvios dienos. Pirtis ir atpalaiduojanti sūkurinė vonia čia tampa ne tik poilsio dalimi, bet ir natūraliu komandos ryšio stiprinimo ritualu.
                </p>
                <p>
                  Norintiems gilesnės patirties, siūlome profesionalaus pirtininko paslaugą. Vedamas pirties ritualas padeda:
                </p>
              </div>
              <ul className="list-disc space-y-1 text-white mb-6 text-left pl-4">
                <li>atpalaiduoti kūną po ilgo sėdėjimo ar aktyvios veiklos,</li>
                <li>sumažinti stresą ir perdegimo jausmą,</li>
                <li>sustiprinti bendrystę komandoje be spaudimo ar dirbtinių veiklų.</li>
              </ul>
            </div>
          </div>

          {/* Image - 40% */}
          <div className="lg:col-span-4 h-[400px] lg:h-[600px] overflow-hidden">
            <img 
              src="/img/darbostogos-4.jpg" 
              alt="SPA erdvė" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Catering Section - White background, image left (30%), text right (70%) */}
      <section className="border-b-[3px] border-black bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Image - 30% */}
          <div className="lg:col-span-3 h-[400px] lg:h-[500px] overflow-hidden">
            <img 
              src="/img/darbostogos-5.jpg" 
              alt="Maitinimas" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content - 70% */}
          <div className="lg:col-span-7 px-8 py-12 lg:py-16 lg:px-16 flex flex-col justify-center items-center text-center">
            <div className="max-w-2xl">
              <h2 className="text-black mb-6 tracking-wide leading-tight" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
                MAITINIMAS BE RŪPESČIŲ - PATOGU DARBOSTOGOMS IR KOMANDOMS
              </h2>
              <div className="space-y-2 text-black leading-relaxed">
                <p>
                  Planuojant darbostogas ar komandos poilsį „Sporto krante", svarbu, kad kasdieniai sprendimai netaptų papildomu galvos skausmu. Todėl maitinimu galime pasirūpinti mes - nuo pusryčių iki vakarienės, kad Jūsų komanda galėtų susitelkti į darbą, bendravimą ir poilsį.
                </p>
                <p>
                  Siūlome galimybę organizuoti pusryčius, pietus ir vakarienę, pritaikytus komandos dienos ritmui. Nesvarbu, ar tai intensyvi darbo diena, ar lėtas darbostogų grafikas - maitinimas derinamas taip, kad būtų patogu, subalansuota ir laiku.
                </p>
                <p>
                  Tiekėjus galite rinktis iš mūsų patikrintų ir rekomenduojamų partnerių, kurie užtikrina kokybę, šviežumą ir lankstumą. Esant poreikiui, galime pritaikyti meniu pagal jūsų poreikius.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Territory Section - Gold background */}
      <section className="py-12 border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-center text-black mb-6 tracking-wide" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
            SPORTO KRANTO TERITORIJA - POILSIUI, JUDESIUI IR BUVIMUI KARTU
          </h2>
          <div className="space-y-2 text-black leading-relaxed text-center">
            <p>
              „Sporto kranto" teritorija sukurta taip, kad kiekvienas čia rastų savo tempą - tiek aktyviam judesiui, tiek ramiam poilsiui po darbų ar susitikimų. Erdvi, prižiūrėta ir gamtos apsupta aplinka leidžia lengvai atsitraukti nuo kasdienės rutinos ir būti gryname ore.
            </p>
            <p>
              Teritorijoje įkurti modernūs teniso kortai, tinkantys tiek aktyviam laisvalaikui, tiek draugiškoms komandinėms varžyboms. Tai puiki galimybė išjudinti kūną, iškrauti mintis ir natūraliai įnešti energijos į darbostogų dieną.
            </p>
            <p>
              Prie pat ežero įrengta prieplauka su galimybe išsimaudyti ežere. Vasaros metu tai tampa viena mėgstamiausių vietų - rytiniam atsigaivinimui, ramiam poilsiui ar vakariniam atsipalaidavimui po pirties.
            </p>
            <p>
              Šiltuoju sezonu galima grilinti lauke, organizuoti jaukius bendrus vakarus ar neformalius komandos susibūrimus gamtoje. Norintiems daugiau sąmoningo judesio, siūlome galimybę užsisakyti jogos, balanso ar kitas lengvas treniruotes, kurios padeda atstatyti kūno balansą po darbo dienos.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Darbostogos;
